import { render, staticRenderFns } from "./ReportViewContratoJugadores.vue?vue&type=template&id=8fd59ff0&scoped=true&"
import script from "./ReportViewContratoJugadores.vue?vue&type=script&lang=js&"
export * from "./ReportViewContratoJugadores.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewContratoJugadores.vue?vue&type=style&index=0&id=8fd59ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd59ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VIcon,
  VSnackbar,
  VTooltip,
})
